import React from 'react'

export const FooterContactIcon = () => (
  <svg width={60} height={48}>
    <g fill="none" fillRule="evenodd" transform="translate(3 1)">
      <circle cx="22.642" cy="23.167" r="21.642" fill="#F9DFDF" />
      <path
        stroke="gray"
        strokeLinecap="round"
        strokeWidth={2}
        d="M21.85 37H3.9C1.746 37 0 35.074 0 32.698V4.302C0 1.926 1.746 0 3.9 0h31.2C37.254 0 39 1.926 39 4.302v11.036M7 9.144h13.122M7 15.644h24.407M7 22.335h17.024M7 29.025h17.024"
      />
      <path
        fill="#D32A2A"
        d="M51 24H31a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h3v6l8-6h9a2 2 0 0 0 2-2V26a2 2 0 0 0-2-2z"
      />
      <circle cx={35} cy="32.5" r="1.5" fill="#FFF" />
      <circle cx={41} cy="32.5" r="1.5" fill="#FFF" />
      <circle cx={47} cy="32.5" r="1.5" fill="#FFF" />
    </g>
  </svg>
)
